import {
  INICIA_ALUNO,
  SALVA_ALUNO,
  REMOVE_ALUNO,
  NOVO_ALUNO,
  BUSCA_ALUNO_EDICAO,
  INICIO_ALUNO_SUCESSO,
  SALVA_ALUNO_SUCESSO,
  REMOVE_ALUNO_SUCESSO,
  BUSCA_ALUNO_EDICAO_SUCESSO,
  ATUALIZA_ALUNO,
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  HIDE_MESSAGE,
  LISTA_ALUNO,
  LISTA_ALUNO_SUCESSO,
  LIMPAR_ALUNO,
  LISTA_ESCOLAS_ALUNO,
  LISTA_ESCOLAS_ALUNO_SUCESSO,
  LISTA_CURSOS_POR_ESCOLA_ALUNO,
  LISTA_CURSOS_POR_ESCOLA_ALUNO_SUCESSO,
  LISTA_SERIES_POR_CURSO_ALUNO,
  LISTA_SERIES_POR_CURSO_ALUNO_SUCESSO,
  LISTA_TURMAS_POR_SERIE_ALUNO,
  LISTA_TURMAS_POR_SERIE_ALUNO_SUCESSO,
  APLICA_FILTRO_ALUNO
} from 'constants/ActionTypes';

/*#############################################################################################*/
/* ------------------------------ Actions Fundamentais CRUD -----------------------------------*/

export const onChangeFilterAluno = (e) => {
  return {
    type: APLICA_FILTRO_ALUNO,
    payload: e.target.value
  }
};

export const iniciaAluno = () => {
  return {
    type: INICIA_ALUNO
  };
};

export const salvaAluno = (aluno) => {
  return {
    type: SALVA_ALUNO,
    payload: aluno
  };
};

// Opcional: ação explícita para atualizar aluno (se quisermos separar do SALVA)
export const atualizaAluno = (aluno) => {
  return {
    type: ATUALIZA_ALUNO,
    payload: aluno
  };
};

export const removeAluno = (id) => {
  return {
    type: REMOVE_ALUNO,
    payload: id
  };
};

export const listaAluno = (filtros) => {
  let payload = {};
  if (typeof filtros === 'string') {
    payload = { nome: filtros };
  } else {
    payload = filtros || {};
  }

  return {
    type: LISTA_ALUNO,
    payload
  };
};


/*#############################################################################################*/
/* ---------------------------- Actions do Fluxo de Navegação ---------------------------------*/

export const novoAluno = () => {
  return {
    type: NOVO_ALUNO
  };
};

export const buscaAlunoEdicao = (id) => {
  return {
    type: BUSCA_ALUNO_EDICAO,
    payload: id
  };
};

/*#############################################################################################*/
/* --------------------------- Actions de respostas actions anteriores ------------------------*/

export const inicioAlunoSucesso = (alunos) => {
  return {
    type: INICIO_ALUNO_SUCESSO,
    payload: { alunos }
  }
};

export const salvaAlunoSucesso = (mensagem) => {
  return {
    type: SALVA_ALUNO_SUCESSO,
    payload: mensagem
  }
};

export const removeAlunoSucesso = (mensagem) => {
  return {
    type: REMOVE_ALUNO_SUCESSO,
    payload: mensagem
  }
};

export const buscaAlunoEdicaoSucesso = (aluno) => {
  return {
    type: BUSCA_ALUNO_EDICAO_SUCESSO,
    payload: aluno
  };
};

export const listaAlunoSucesso = (dados) => {
  return {
    type: LISTA_ALUNO_SUCESSO,
    payload: dados
  };
};

export const limparFiltroAluno = () => {
  return {
    type: LIMPAR_ALUNO,
  };
};

/*#############################################################################################*/
/* ---------------------------------- Outras Actions Auxiliares -------------------------------*/

export const exibirMensagemErro = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  };
};

export const showAuthLoader = () => {
  return {
    type: ON_SHOW_LOADER,
  };
};

export const hideMessage = () => {
  return {
    type: HIDE_MESSAGE,
  };
};

export const showAuthMessage = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  };
};

// Actions para filtros auxiliares (Escola, Curso, Série, Turma)
export const listaEscolasAluno = () => ({ type: LISTA_ESCOLAS_ALUNO });
export const listaEscolasAlunoSucesso = (escolas) => ({ type: LISTA_ESCOLAS_ALUNO_SUCESSO, payload: escolas });

export const listaCursosPorEscolaAluno = (escolaId) => ({ type: LISTA_CURSOS_POR_ESCOLA_ALUNO, payload: escolaId });
export const listaCursosPorEscolaAlunoSucesso = (cursos) => ({ type: LISTA_CURSOS_POR_ESCOLA_ALUNO_SUCESSO, payload: cursos });

export const listaSeriesPorCursoAluno = (cursoId) => ({ type: LISTA_SERIES_POR_CURSO_ALUNO, payload: cursoId });
export const listaSeriesPorCursoAlunoSucesso = (series) => ({ type: LISTA_SERIES_POR_CURSO_ALUNO_SUCESSO, payload: series });

export const listaTurmasPorSerieAluno = (param1, param2, param3) => {
  if (param1 && typeof param1 === 'object') {
    return { type: LISTA_TURMAS_POR_SERIE_ALUNO, payload: param1 };
  }
  if (param1 === 'ALL') {
    return { type: LISTA_TURMAS_POR_SERIE_ALUNO, payload: 'ALL' };
  }
  return { type: LISTA_TURMAS_POR_SERIE_ALUNO, payload: { serieId: param1, cursoId: param2, escolaId: param3 } };
};
export const listaTurmasPorSerieAlunoSucesso = (turmas) => ({ type: LISTA_TURMAS_POR_SERIE_ALUNO_SUCESSO, payload: turmas });
